import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import { SAvatar, SButton, SIcon } from '@strana-artw/ui-kit';
import { defineComponent, getCurrentInstance, reactive } from 'vue';
import { consoleError } from '@/shared/lib/utils/console';
import { mapIcon, positionClass, positionList } from './notifyConstants';
import { applyDefaults, buildMetaClasses, collectActions, createNotif, finalizeActions, groups, insertFreshNotif, normalizeConfig, resolveGroup, resolvePosition, resolveProgress, resolveSpinner, resolveTimeout, updateGroupedNotif } from './notifyLib';
export default defineComponent({
  name: 'VNotifications',
  setup: function setup() {
    var instance = getCurrentInstance();
    var vm = function vm() {
      return instance === null || instance === void 0 ? void 0 : instance.proxy;
    };
    var notifs = reactive(positionList.reduce(function (acc, pos) {
      acc[pos] = [];
      return acc;
    }, {}));
    function remove(notif) {
      clearTimeout(notif.meta.timer);
      var index = notifs[notif.position].indexOf(notif);
      if (index !== -1) {
        var _vm, _vm2;
        if (notif.group !== undefined) {
          delete groups[notif.meta.group];
        }
        var el = (_vm = vm()) === null || _vm === void 0 ? void 0 : _vm.$refs["notif_".concat(notif.meta.uid)];
        if (el instanceof HTMLElement) {
          var _getComputedStyle = getComputedStyle(el),
            width = _getComputedStyle.width,
            height = _getComputedStyle.height;
          el.style.left = "".concat(el.offsetLeft, "px");
          el.style.width = width;
          el.style.height = height;
        }
        notifs[notif.position].splice(index, 1);
        (_vm2 = vm()) === null || _vm2 === void 0 || _vm2.$forceUpdate();
        if (typeof notif.onDismiss === 'function') {
          notif.onDismiss();
        }
      }
    }
    function add(config, originalApi) {
      var _vm3;
      if (!config) {
        return consoleError('parameter required');
      }
      var Api;
      var notif = createNotif();
      var dismiss = function dismiss() {
        remove(notif);
        Api = undefined;
      };
      applyDefaults(notif, config);
      config = normalizeConfig(notif, config, originalApi);
      Object.assign(notif, originalApi.types[config.type || notif.type], config);
      if (typeof notif.icon === 'function') {
        notif.icon = notif.icon.call(vm());
      }
      resolveSpinner(notif);
      notif.meta = {
        hasMedia: Boolean(notif.spinner !== false || notif.icon || notif.avatar)
      };
      if (!resolvePosition(notif, config)) {
        return;
      }
      if (!resolveTimeout(notif, config)) {
        return;
      }
      resolveProgress(notif);
      notif.actions = collectActions(notif, config, originalApi, dismiss);
      if (notif.multiLine === undefined) {
        notif.multiLine = notif.actions.length > 1;
      }
      buildMetaClasses(notif);
      resolveGroup(notif);
      finalizeActions(notif);
      var original = groups[notif.meta.group];
      if (original === undefined) {
        insertFreshNotif(notifs, notif);
      } else if (!updateGroupedNotif(notifs, notif, original, config)) {
        return;
      }
      (_vm3 = vm()) === null || _vm3 === void 0 || _vm3.$forceUpdate();
      if (notif.timeout > 0) {
        notif.meta.timer = setTimeout(function () {
          dismiss();
        }, notif.timeout + 1000);
      }
      if (notif.group !== undefined) {
        return function (props) {
          if (props !== undefined) {
            consoleError('trying to update a grouped one which is forbidden', config);
          } else {
            dismiss();
          }
        };
      }
      Api = {
        dismiss: dismiss,
        config: config,
        notif: notif
      };
      if (originalApi !== undefined) {
        Object.assign(originalApi, Api);
        return;
      }
      return function (props) {
        if (Api !== undefined) {
          if (props === undefined) {
            Api.dismiss();
          } else {
            var newNotif = _objectSpread(_objectSpread(_objectSpread({}, Api.config), props), {}, {
              group: false,
              position: notif.position
            });
            add(newNotif, Api);
          }
        }
      };
    }
    return {
      notifs: notifs,
      add: add,
      remove: remove
    };
  },
  render: function render(h) {
    var _this = this;
    return h('div', {
      staticClass: 'v-notifications'
    }, positionList.map(function (pos) {
      return h('transition-group', {
        key: pos,
        staticClass: positionClass[pos],
        tag: 'div',
        props: {
          name: "v-notification--".concat(pos),
          mode: 'out-in'
        }
      }, _this.notifs[pos].map(function (notif) {
        var msgChild;
        var meta = notif.meta;
        var msgData = {
          staticClass: 'v-notification__message col'
        };
        if (notif.html === true) {
          msgData.domProps = {
            innerHTML: notif.caption ? "<div>".concat(notif.message, "</div><div class=\"v-notification__caption\">").concat(notif.caption, "</div>") : notif.message
          };
        } else {
          var msgNode = [notif.message];
          msgChild = notif.caption ? [h('div', msgNode), h('div', {
            staticClass: 'v-notification__caption'
          }, [notif.caption])] : msgNode;
        }
        var mainChild = [];
        if (meta.hasMedia === true) {
          if (notif.spinner !== false) {
            mainChild.push(h(notif.spinner, {
              staticClass: 'v-notification__spinner',
              props: {
                indeterminate: true
              }
            }));
          } else if (notif.icon) {
            mainChild.push(h(SIcon, {
              staticClass: 'v-notification__icon',
              attrs: {
                role: 'img'
              },
              props: {
                icon: mapIcon(notif.icon),
                size: '24'
              }
            }));
          } else if (notif.avatar) {
            mainChild.push(h(SAvatar, {
              staticClass: 'v-notification__avatar',
              attrs: {
                'aria-hidden': 'true'
              },
              props: {
                size: 36,
                src: notif.avatar
              }
            }));
          }
        }
        mainChild.push(h('div', msgData, msgChild));
        var child = [h('div', {
          staticClass: meta.contentClass
        }, mainChild)];
        notif.progress === true && child.push(h('div', {
          key: "".concat(meta.uid, "|p|").concat(meta.badge),
          staticClass: 'v-notification__progress',
          style: meta.progressStyle,
          class: notif.progressClass
        }));
        notif.actions !== undefined && child.push(h('div', {
          staticClass: meta.actionsClass
        }, notif.actions.map(function (action) {
          var p = action.props || {};
          var data = {
            staticClass: action.staticClass,
            style: action.style,
            attrs: action.attrs,
            on: action.on,
            props: {
              equal: Boolean(p.icon),
              size: p.small === true ? 'x-small' : 'small',
              theme: 'ghost'
            }
          };
          return p.icon === true ? h(SButton, data, [h(SIcon, {
            props: {
              icon: mapIcon(p.iconName),
              size: '16'
            }
          })]) : h(SButton, data, [p.label]);
        })));
        meta.badge > 1 && child.push(h('div', {
          key: "".concat(meta.uid, "|").concat(meta.badge),
          staticClass: meta.badgeStaticClass,
          style: notif.badgeStyle,
          class: notif.badgeClass
        }, [meta.badge]));
        return h('div', {
          ref: "notif_".concat(meta.uid),
          key: meta.uid,
          staticClass: meta.staticClass,
          attrs: meta.attrs
        }, [h('div', {
          staticClass: meta.wrapperClass
        }, child)]);
      }));
    }));
  }
});